<mat-dialog-content class="container">
	<div class="flex column">
		<button class="align-end" mat-icon-button (click)="dismiss()"> <mat-icon>close</mat-icon> </button>
		<div class="flex space-between">
			<h4>{{ 'general.change_quiz_percentage' | translateWithKeys }}</h4>
		</div>
		<p class="body1 mt-14">{{ 'general.change_quiz_percentage_description' | translateWithKeys }}</p>
		<mat-form-field appearance="outline" class="mt-14">
			<input matInput type="number" min="0" max="100" [(ngModel)]="percentage"
				placeholder="{{ 'general.change_quiz_percentage_placeholder' | translateWithKeys }}">
			<span matSuffix class='icon-percentage-suffix'>%</span>
		</mat-form-field>
		@if (!isValid) {
			<span class="text-warn">{{ 'general.change_quiz_percentage_invalid' | translateWithKeys }}</span>
		}
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<div class="flex row end gap-12">
		<button mat-stroked-button class="button" (click)="dismiss()">
			{{ 'general.cancel' | translateWithKeys }}
		</button>
		<button mat-stroked-button class="button primary" [disabled]="!isValid" (click)="save()">
			{{ 'general.save' | translateWithKeys }}
		</button>
	</div>
</mat-dialog-actions>
